import styles from './LeftDrawer.module.scss'
import { ChatCircleDotsIcon } from '@phosphor-icons/react'
import { ChatListItem } from '../ChatListItem/ChatListItem'
import {
    ScoopText,
    ScoopDrawer,
    ScoopButton,
    ScoopTooltip,
    ScoopColumn,
    ScoopDivider,
} from '../../../../ui'

const STARTER_PROMPTS = [
    {
        category: 'Ask about your dataset',
        prompts: [
            { text: 'What columns are in my dataset?', enabled: true },
            { text: 'How many rows are in my dataset?', enabled: true },
            { text: 'Show me a summary of my data', enabled: true },
        ],
    },
    {
        category: 'Get visualizations or tables',
        prompts: [
            { text: 'Show me revenue as a line chart by month', enabled: false },
            { text: 'Create a bar chart of sales by category', enabled: false },
            { text: 'Show me the top 10 customers by revenue', enabled: false },
            { text: 'Display quarterly growth trends', enabled: false },
        ],
    },
    {
        category: 'Analyze patterns and insights',
        prompts: [
            { text: 'What are the main trends in my data?', enabled: true },
            { text: 'Show me any anomalies or outliers', enabled: true },
            { text: 'What patterns exist in customer behavior?', enabled: true },
            { text: 'Identify seasonal trends', enabled: true },
        ],
    },
    {
        category: 'Compare and contrast',
        prompts: [
            { text: 'How is this month different than last month?', enabled: false },
            { text: 'Compare performance across regions', enabled: false },
            { text: 'Show year-over-year growth', enabled: false },
            { text: 'What changed between Q1 and Q2?', enabled: false },
        ],
    },
]

export const LeftDrawer = ({
    drawerOpen,
    persistentChats,
    loadingChats,
    currentChat,
    selectChat,
    handleRenameChat,
    handleDeleteChat,
    handleNewChat,
    handleStarterPrompt,
    isChatDeleting,
}) => {
    return (
        <ScoopDrawer open={drawerOpen} anchor="left" variant="persistent" className={styles.drawer}>
            <ScoopColumn className={styles.container}>
                {/* Top Half - Saved Chats */}
                <ScoopColumn className={styles.topHalf}>
                    {/* Chat History Header */}
                    <div className={styles.header}>
                        <ScoopText className={styles.headerTitle}>Recent Chats</ScoopText>
                        <ScoopTooltip title="Start new chat">
                            <ScoopButton
                                variant="text"
                                size="xxs"
                                onClick={handleNewChat}
                                className={styles.newChatButton}
                            >
                                <ChatCircleDotsIcon size={18} weight="regular" />
                            </ScoopButton>
                        </ScoopTooltip>
                    </div>

                    {/* Chat History List */}
                    <div className={styles.chatList}>
                        {loadingChats ? (
                            <div className={styles.loadingContainer}>
                                <ScoopText className={styles.loadingText}>
                                    Loading chats...
                                </ScoopText>
                            </div>
                        ) : persistentChats.length > 0 ? (
                            persistentChats.map((chat) => (
                                <ChatListItem
                                    key={chat.chatID}
                                    chat={chat}
                                    isSelected={currentChat?.chatID === chat.chatID}
                                    onClick={selectChat}
                                    onRename={handleRenameChat}
                                    onDelete={handleDeleteChat}
                                    showDeleteButton={true}
                                    isDeleting={isChatDeleting?.(chat.chatID)}
                                />
                            ))
                        ) : (
                            <ScoopColumn className={styles.emptyStateContainer}>
                                <ScoopText className={styles.emptyStateText}>
                                    No saved chats yet
                                </ScoopText>
                                <ScoopText className={styles.emptyStateSubtext}>
                                    Start a conversation to see it here
                                </ScoopText>
                            </ScoopColumn>
                        )}
                    </div>
                </ScoopColumn>

                {/* Divider */}
                <ScoopDivider className={styles.divider} />

                {/* Bottom Half - Starter Prompts */}
                <ScoopColumn className={styles.bottomHalf}>
                    {/* Starter Prompts Header */}
                    <div className={styles.starterPromptsHeader}>
                        <ScoopText className={styles.starterPromptsTitle}>
                            Example Prompts
                        </ScoopText>
                    </div>

                    {/* Starter Prompts List */}
                    <div className={styles.promptsList}>
                        {STARTER_PROMPTS.map((category, categoryIndex) => (
                            <div key={categoryIndex} className={styles.categoryBox}>
                                <ScoopText className={styles.categoryTitle}>
                                    {category.category}
                                </ScoopText>
                                {category.prompts.map((prompt, promptIndex) => (
                                    <div
                                        key={promptIndex}
                                        className={`${styles.promptItem} ${!prompt.enabled ? styles.disabled : ''}`}
                                    >
                                        <div className={styles.promptContent}>
                                            <ScoopText
                                                className={`${styles.promptText} ${!prompt.enabled ? styles.disabled : ''}`}
                                                title={
                                                    !prompt.enabled
                                                        ? 'This prompt is dataset-specific'
                                                        : ''
                                                }
                                            >
                                                {prompt.text}
                                            </ScoopText>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </ScoopColumn>
            </ScoopColumn>
        </ScoopDrawer>
    )
}
